import axios from 'axios'

const namespaced = true

const state = {
  token: localStorage.getItem('token_castle_authorization') || '',
  userInfo: JSON.parse(localStorage.getItem('castleUserInfo')),
  status: '',
  password: window.atob(localStorage.getItem('p_s')) || ''
}
const actions = {
  login ({ commit, state, dispatch }, data) {
    commit('auth_request')
    return new Promise((resolve, reject) => {
      const url = '/api/private/v3.0/auth/'
      axios.post(url, data)
        .then(response => {
          localStorage.setItem('token_castle_authorization', 'Token ' + response.data.token)
          axios.defaults.headers.common.Authorization = 'Token ' + response.data.token
          commit('auth_success', 'Token ' + response.data.token)
          resolve()
        })
        .catch(error => {
          commit('auth_error', error)
          reject(error)
        })
    })
  },
  showUserInfo ({ state, rootState, commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/private/v3.0/user/')
        .then(response => {
          localStorage.setItem('castleUserInfo', JSON.stringify(response.data))
          commit('setUserInfo', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  logout ({ commit }) {
    return axios.post('/api/private/v3.0/logout/')
      .then(() => {
        commit('logout')
        localStorage.removeItem('token_castle_authorization')
        localStorage.removeItem('castleUserInfo')
        localStorage.removeItem('p_s')
        delete axios.defaults.headers.common.Authorization
      })
      .catch(error => {
        console.log(error)
      })
  }
}
const mutations = {
  setUserInfo (state, data) {
    state.userInfo = data
  },
  auth_request (state) {
    state.status = 'loading'
  },
  auth_success (state, token) {
    state.status = 'success'
    state.token = token
  },
  auth_error (state) {
    state.status = 'error'
  },
  logout (state) {
    state.status = ''
    state.token = ''
  }
}
const getters = {
  isAuthenticated (state) {
    return !!state.token
  },
  authStatus: state => state.status
}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
